module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_3.293c0b89.png";